import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MenuService } from './menu.service';
import { MenuNode } from './menu-tree';

const SUBSET_MATCH = { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' } as const;
const EXACT_MATCH = { paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' } as const;

let nextSubmenuId = 0;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-menuitem]',
  templateUrl: './menuitem.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuitemComponent {
  @Input({ required: true }) node!: MenuNode;

  @HostBinding('class.layout-root-menuitem')
  get root(): boolean {
    return this.node.section;
  }

  // Read from the template (not host bindings) so the signal reads drive OnPush change detection.
  get expanded(): boolean {
    return this.menuService.isExpanded(this.node.key);
  }

  get inActiveTrail(): boolean {
    return this.menuService.activeTrail().has(this.node.key);
  }

  readonly submenuId = `layout-submenu-${nextSubmenuId++}`;
  readonly subsetMatch = SUBSET_MATCH;
  readonly exactMatch = EXACT_MATCH;

  constructor(private menuService: MenuService) { }

  toggle(): void {
    this.menuService.toggle(this.node.key);
  }

  /** Opening a group's own page also reveals its sub-pages. */
  expand(): void {
    this.menuService.setExpanded([this.node.key], true);
  }

  trackByKey(_: number, node: MenuNode): string {
    return node.key;
  }
}
